import { parser } from 'posthtml-parser'

type TNodeText = string | number
export type TNodeTag<Tag extends string = string> = {
  tag?: Tag
  attrs?: Record<string, string | number | boolean>
  content?: TNode[]
}

export type TNode = TNodeText | TNodeTag

export const contentHtmlParser = (html: string) =>
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- posthtml-parser Node is wider
  parser(html, {
    decodeEntities: true,
    lowerCaseAttributeNames: true,
    lowerCaseTags: true,
    recognizeSelfClosing: true,
    recognizeNoValueAttribute: true,
  }) as TNode[]
